import { KpiRow } from './kpi-setup-constants';

export const reorderKpis = (items: KpiRow[], fromIndex: number, toIndex: number): KpiRow[] => {
  const reordered = [...items];
  const [movedItem] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, movedItem);
  return reordered.map((kpi, index) => ({ ...kpi, kpi_order: index + 1 }));
};

export const getUndefinedKpiKeys = (kpis: KpiRow[]): string[] =>
  kpis.filter(kpi => kpi.kpi_order === null).map(kpi => kpi.kpi);

export const getKpisToSave = (
  kpiItems: KpiRow[],
  originalKpiItems: KpiRow[],
  undefinedKpiKeys: string[]
): KpiRow[] =>
  kpiItems.reduce<KpiRow[]>((kpisToSend, kpi, index) => {
    const originalKpi = originalKpiItems[index];
    if (kpi.kpi !== originalKpi.kpi) {
      return [...kpisToSend, kpi];
    }
    if (undefinedKpiKeys.includes(kpi.kpi)) {
      return [...kpisToSend, { ...kpi, kpi_order: index + 1 }];
    }
    return kpisToSend;
  }, []);
